import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { Identifiable, List } from "@planzone/dto";
import { reduceTask } from "../task";
import { reduceMilestone } from "../milestone";
import { reduceEvent } from "../event";

function handleAssignTagRequest(
  list: Identifiable<List>,
  data: Boundaries["assignTag"]["request"],
): Identifiable<List> {
  return list.uuid === data.assignableId
    ? {
        ...list,
        tags: list.tags ? [...list.tags, data.tag] : [data.tag],
      }
    : {
        ...list,
        tasks: list.tasks.map((task) =>
          reduceTask(task, { type: events.assignTagRequested, data }),
        ),
        milestones: list.milestones.map((milestone) =>
          reduceMilestone(milestone, { type: events.assignTagRequested, data }),
        ),
        events: list.events.map((event) =>
          reduceEvent(event, { type: events.assignTagRequested, data }),
        ),
        subLists: list.subLists.map((subList) =>
          handleAssignTagRequest(subList, data),
        ),
      };
}

function handleAssignTagSuccess(
  list: Identifiable<List>,
  data: Boundaries["assignTag"]["success"],
): Identifiable<List> {
  if (list.uuid === data.assignableId) {
    const tagExists = list.tags?.some(({ name }) => name === data.tag.name);
    return tagExists
      ? list
      : {
          ...list,
          tags: list.tags ? [...list.tags, data.tag] : [data.tag],
        };
  }

  return {
    ...list,
    tasks: list.tasks.map((task) =>
      reduceTask(task, { type: events.assignTagSucceeded, data }),
    ),
    milestones: list.milestones.map((milestone) =>
      reduceMilestone(milestone, { type: events.assignTagSucceeded, data }),
    ),
    events: list.events.map((event) =>
      reduceEvent(event, { type: events.assignTagSucceeded, data }),
    ),
    subLists: list.subLists.map((subList) =>
      handleAssignTagSuccess(subList, data),
    ),
  };
}

function handleAssignTagFailure(
  list: Identifiable<List>,
  data: Boundaries["assignTag"]["failure"],
): Identifiable<List> {
  return list.uuid === data.assignableId
    ? {
        ...list,
        tags: list.tags.filter(({ name }) => name !== data.tag.name),
      }
    : {
        ...list,
        tasks: list.tasks.map((task) =>
          reduceTask(task, { type: events.assignTagFailed, data }),
        ),
        milestones: list.milestones.map((milestone) =>
          reduceMilestone(milestone, { type: events.assignTagFailed, data }),
        ),
        events: list.events.map((event) =>
          reduceEvent(event, { type: events.assignTagFailed, data }),
        ),
        subLists: list.subLists.map((subList) =>
          handleAssignTagFailure(subList, data),
        ),
      };
}

export {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
};
